import { Helmet } from 'react-helmet';
import { Outlet } from 'react-router-dom';
import { Section, SectionLink, SectionName } from '../components/Chrome';
import Icon from '../components/Icon';

const SettingsMainPage = () => (
  <>
    <Helmet>
      <title>Main</title>
    </Helmet>
    <Section>
      <SectionName isSecondLevel>Main</SectionName>
      <SectionLink to="edit-name">
        Edit name
        <Icon name="arrow-right" />
      </SectionLink>
      <SectionLink to="edit-email">
        Edit email
        <Icon name="arrow-right" />
      </SectionLink>
      <SectionLink to="edit-avatar">
        Edit avatar
        <Icon name="arrow-right" />
      </SectionLink>
    </Section>
    <Outlet />
  </>
);

export default SettingsMainPage;
